export const getTravelPurpose = (state) => state.travelPurpose.travelPurpose;
